import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import './sentry'; // Import Sentry for global error tracking
import { BrowserRouter,  } from "react-router";
import { ClerkProvider } from '@clerk/react'
import * as Sentry from '@sentry/react';
import { ConfigProvider } from './config/ConfigProvider.tsx';

async function loadConfig(): Promise<void> {
  try {
    const response = await fetch('/config.json', {
      headers: {
        'Cache-Control': 'no-cache',   // Ensure fresh config in dev
      },
    });
  
  if (!response.ok) throw new Error('Failed to load config.json');
  
  window.ENV = await response.json();   // ← Now TypeScript knows this

  if (!window.ENV.CLERK_PUBLISHABLE_KEY) {
    throw new Error('Missing CLERK_PUBLISHABLE_KEY in config.json');
  }
  } catch (error) {
    console.error('Failed to load runtime config:', error);
    // Optional: show a nice error screen instead of crashing
    document.getElementById('root')!.innerHTML = `
      <div style="padding: 2rem; text-align: center; color: red;">
        <h1>Configuration Error</h1>
        <p>Failed to load application configuration.</p>
      </div>
    `;
    throw error;
  }
}

(async () => {
  await loadConfig();
  const container = document.getElementById("root")!;
  const root = createRoot(container, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
  });

  root.render(
    <StrictMode>
      <ConfigProvider>
      <ClerkProvider publishableKey={window.ENV.CLERK_PUBLISHABLE_KEY}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ClerkProvider>
      </ConfigProvider>
    </StrictMode>
  );
})();
